/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');
var NotesView = require('common/views/NotesView');

var GetNotes = require('../services/GetNotes');
var SubmitNoteUpdate = require('../services/SubmitNoteUpdate');

module.exports = {
  channel: 'cf',

  event: 'build:notes-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: buildNotesView(data)
    });
  }
};

function buildNotesView(data) {
  var deferred = $.Deferred();

  $.when(GetNotes({ objectId: data.objectId, objectTypeId: data.objectTypeId }))
    .done(function(notes, noteTypes) {
      deferred.resolve(
        new NotesView({
          submitNoteService: SubmitNoteUpdate,
          managerRole: 'SC - Manager',
          model: new Backbone.Model({
            objectId: data.objectId,
            objectTypeId: data.objectTypeId,
            notes: notes
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
